import useResize from 'hooks/useResize';
import React from 'react';
import ResultTableDesktop from './ResultTableDesktop';
import ResultTableMobile from './ResultTableMobile';
import { ResultTableProps } from './types';

const ResultTable = (props: ResultTableProps) => {
  const { isMobile } = useResize();
  return isMobile ? <ResultTableMobile {...props} /> : <ResultTableDesktop {...props} />;
};

export default ResultTable;
